import React from 'react';
import { Fab } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import './styles.css';

const FloatingMenu: React.FC = () => (
  <>
    <Fab
      size="small"
      aria-label="Chat on WhatsApp"
      className="whatsapp-button"
      onClick={() => window.open('https://wa.me/+94777246072')}
    >
      <WhatsAppIcon />
    </Fab>
  </>
);

export default FloatingMenu;
